import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {PdfExportService} from '../../../services/export-pdf/pdf-export.service';
import {UserService} from '../../../services/user.service';

@Component({
  selector: 'demographic-fallback',
  templateUrl: './demographic-fallback.component.html',
  styleUrls: ['./demographic-fallback.component.scss']
})
export class DemographicFallbackComponent implements OnInit, AfterViewInit {

  static COMPONENT_NAME = 'DemographicFallbackComponent';
  @Input() messageTitle: string;
  @Input() messageContent: string;
  @Input() showNotificationPopup = false;

  constructor(private translate: TranslateService, private pdfService: PdfExportService, private userService: UserService) {
  }

  ngOnInit() {
    if (!this.messageTitle) {
      this.messageTitle = this.translate.instant('demographic_fallback.no_data_message_header');
    }

    if (!this.messageContent) {
      this.messageContent = this.translate.instant('demographic_fallback.no_data_message_detail');
    }

    if (this.showNotificationPopup) {
      this.userService.doInvalidActionByLevel('Insight Limits', this.messageContent);
    }
  }

  arrayGenByNumber(n: number): any[] {
    return Array(n);
  }

  ngAfterViewInit() {
    this.pdfService.incrementNumberReportReady(DemographicFallbackComponent.COMPONENT_NAME);
  }

}



// WEBPACK FOOTER //
// ./src/app/main/influencer/demographic-fallback/demographic-fallback.component.ts